import { TEditTeam, TLocation } from '../../../types';

const INITIAL_TEAM_FORM: TEditTeam = {
  teamName: '',
  commissionModel: {
    compensation: 'split',
    goalsBase: 'team',
    baseLocation: {} as TLocation,
  },
  members: [],
  commissionPlan: null,
  locationTag: {} as TLocation,
};

export {
  INITIAL_TEAM_FORM,
};
